<template>
  <v-form v-bind="this.$attrs">
    <div class="wrap_filter">
      <div class="inputSearch">
        <v-row class="mb-0">
          <v-col cols="12" md="4">
            <AutocompleteSubjectGroup
              v-model="subjectGroup"
              clear-icon="mdi-close"
              label="Lĩnh vực"
              item-text="title"
              outlined
              dense
              return-object
              hide-details
              @change="subjectGroupChanged"
            />
          </v-col>
          <v-col cols="12" md="4">
            <AutocompleteTeacherCard
              :syncedValue.sync="teacher"
              item-text="name"
              clear-icon="mdi-close"
              label="Giáo viên"
              outlined
              dense
              deletable-chips
              hide-details
              :displaySubjectGroup="true"
              :filter="teacherFilter"
            />
          </v-col>
          <v-col v-if="viewIsPaid" cols="12" md="4" lg="4">
            <v-select
              v-model="statusPaid"
              :items="states"
              clear-icon="mdi-close"
              item-text="name"
              item-value="value"
              label="Trạng thái"
              outlined
              dense
              clearable
              hide-details
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="8" lg="6" class="mb-0">
            <div class="d-flex justify-space-between align-center pt-1">
              <v-checkbox
                @change="useNoteChange"
                v-model="useNote"
                class="my-0"
                label="Có ghi chú"
                hide-details
              ></v-checkbox>
              <v-checkbox
                @change="noUseNoteChange"
                v-model="noUseNote"
                class="my-0"
                label="Không ghi chú"
                hide-details
              ></v-checkbox>
              <p></p>
            </div>
          </v-col>
        </v-row>
      </div>
      <div class="buttonSearch ml-6 d-flex justify-end align-end">
        <v-btn class="search-button" height="40" outlined @click="onFilterChanged"> Tìm kiếm </v-btn>
      </div>
    </div>
  </v-form>
</template>

<script>
import AutocompleteSubjectGroup from '@/components/basic/input/AutocompleteSubjectGroup'
import AutocompleteTeacherCard from '@/components/basic/input/AutocompleteTeacherCard'
import { get } from 'lodash'
export default {
  props: {
    viewIsPaid: Boolean
  },
  components: {
    AutocompleteSubjectGroup,
    AutocompleteTeacherCard
  },
  data() {
    return {
      subjectGroup: null,
      teacher: null,
      useNote: null,
      noUseNote: null,
      statusPaid: null,
      states: [
        { name: 'Đã thu', value: true },
        { name: 'Chưa thu', value: 'false' }
      ]
    }
  },
  computed: {
    teacherFilter() {
      return { subjectGroup: get(this.subjectGroup, 'id') }
    }
  },
  methods: {
    subjectGroupChanged(subjectGroup) {
      this.subjectGroup = subjectGroup
      if (subjectGroup && subjectGroup.id) {
        this.teacher = null
      }
    },
    async onFilterChanged() {
      let query = {
        teacher: get(this.teacher, 'id'),
        subject_group: get(this.subjectGroup, 'id'),
        isUseNote: this.useNote !== null ? `${this.useNote}` : null,
        isPaid: this.statusPaid
      }
      this.$emit('onFilter', query)
    },
    useNoteChange() {
      if (this.useNote === true) {
        this.noUseNote = null
      } else {
        this.useNote = null
      }
    },
    noUseNoteChange() {
      if (this.noUseNote === true) {
        this.useNote = false
      } else {
        this.useNote = null
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.wrap_filter {
  display: flex;
}
@media screen and (max-width: 960px) {
  .wrap_filter {
    display: block;
  }
  div.buttonSearch {
    padding-top: 24px;
    margin-left: 0px !important;
  }
}
</style>
